import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
declare var require: any;
const X2JS = require('src/lib/plugins/xml2json.js');

/* istanbul ignore next */
@Injectable()
export class UspsService implements OnInit {
    x2js: any;
    baseUrl = 'https://secure.shippingapis.com/ShippingAPI.dll';
    baseZipValidationUrl = 'https://secure.shippingapis.com/ShippingApi.dll?API=CityStateLookup&XML=';
    constructor(private http: HttpClient) { this.x2js = new X2JS(); }
    ngOnInit() { }
    GetValidatedAddress(addressObj, callback: (result: any) => void): any {
        const uspsAddressObj = {
            'AddressValidateRequest': {
                'Revision': '1',
                'Address': {
                    'Address1': '', 'Address2': addressObj.street, 'City': addressObj.city,
                    'State': addressObj.state, 'Zip5': addressObj.zip, 'Zip4': ''
                },
                '_USERID': '423SOUTH5942'
            }
        };
        const xmlFormat = this.x2js.json2xml_str(uspsAddressObj);
        let requestUrl = this.baseUrl + '?API=Verify&XML=' + (xmlFormat);
        requestUrl = requestUrl.replace('&apos;', '');
        this.http.get(requestUrl, { responseType: 'text' })
            .subscribe(
                res => {
                    const response = this.x2js.xml_str2json(res);
                    const addressTransformed: any = this.FormatAddressResponse(response);
                    callback(addressTransformed);
                },
                err => {
                    console.error(err);
                });
    }
    GetCityStateFromZip(zip, callback: (result: any) => void): any {
        const uspsZipObj = {
                'CityStateLookupRequest': {
                    'ZipCode': {
                        'Zip5': zip,
                        '_ID': '1'
                    },
                    '_USERID': '423SOUTH5942'
                }
            };

        const xmlFormat = this.x2js.json2xml_str(uspsZipObj);
        const requestUrl = this.baseZipValidationUrl + (xmlFormat);
        return this.http.get(requestUrl, { responseType: 'text' })
        .subscribe(
            res => {
                const response = this.x2js.xml_str2json(res);
                callback(response);
            },
            err => {
                console.error(err);
            });
    }
    private FormatAddressResponse(response: any) {
        const addressResponse = response.AddressValidateResponse.Address;
        let addressTransformed: any = null;
        if (addressResponse.Error) {
            return addressResponse;
        } else {
            addressTransformed = {
                street: addressResponse.Address2,
                city: addressResponse.City,
                state: addressResponse.State,
                zip: addressResponse.Zip5,
            };
            return addressTransformed;
        }
    }
    private FormatZipResponse(response: any) {
        const addressResponse = response.AddressValidateResponse.Address;
        let addressTransformed: any = null;
        if (addressResponse.Error) {
            return addressResponse;
        } else {
            addressTransformed = {
                street: addressResponse.Address2,
                city: addressResponse.City,
                state: addressResponse.State,
                zip: addressResponse.Zip5,
            };
            return addressTransformed;
        }
    }
}
